const getSiteUrl = () => {
  return process.env.REACT_APP_SITE_URL || 'https://tz-creation.tabrezdal.com';
};

const getSiteUrlWithoutProtocol = () => {
  return getSiteUrl().replace(/^https?:\/\//, '');
};

const getSiteEmail = () => {
  return 'info@' + getSiteUrlWithoutProtocol();
};

const getCeoUrl = () => {
  return '/about';
};

export { getSiteUrl, getSiteUrlWithoutProtocol, getSiteEmail, getCeoUrl };
